import { useGetScheduledCallsQuery } from '@teachur/http-client';
import type { GetScheduledCallsParams } from '@teachur/http-client';

export const useScheduledCalls = (params?: GetScheduledCallsParams) => {
  return useGetScheduledCallsQuery(params);
};
